module.exports = __webpack_public_path__ + "img/symbol_0.65f1ea9a.png";